import { IRootState } from 'redux/reducer';

export const isNavigationModalOpen = (rootState: IRootState): boolean => {
  return rootState.modals.navigationModal.isOpen;
};
